import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtro-termino-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-termino-obra.component.html',
  styleUrls: ['./filtro-termino-obra.component.scss'],
})
export class FiltroTerminoObraComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Output() terminoObraChange = new EventEmitter<{
    dataInicio: string | null;
    dataFim: string | null;
  }>();

  @Input() terminoObraSelecionado: {
    dataInicio: string | null;
    dataFim: string | null;
  } | null = null;
  dataInicio: string | null = null;
  dataFim: string | null = null;

  @Input() disabled: boolean = false;

  constructor() {}

  ngOnInit() {}

ngOnChanges(changes: SimpleChanges) {
  if (changes['terminoObraSelecionado'] && this.terminoObraSelecionado) {
    // Preenche os inputs sem emitir evento
    this.dataInicio = this.formatDateForInput(this.terminoObraSelecionado.dataInicio);
    this.dataFim = this.formatDateForInput(this.terminoObraSelecionado.dataFim);
  }
}

onDataInicioChange(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  this.dataInicio = value ? this.formatISO8601(new Date(value)) : null;
  this.emitTerminoChange();
}

onDataFimChange(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  this.dataFim = value ? this.formatISO8601(new Date(value)) : null;
  this.emitTerminoChange();
}

private emitTerminoChange() {
  this.terminoObraChange.emit({
    dataInicio: this.dataInicio,
    dataFim: this.dataFim
  });
}


  private formatDateForInput(dateString: string | null): string {
    if (!dateString) return '';
    // Se vier com hora/Z, corta para os 10 primeiros caracteres
    if (dateString.length >= 10 && dateString.includes('-')) {
      return dateString.substring(0, 10);
    }
    // Se vier em outro formato, tenta converter
    const d = new Date(dateString);
    if (!isNaN(d.getTime())) {
      return d.toISOString().substring(0, 10);
    }
    return '';
  }


  private formatISO8601(date: Date): string {
    if (!date || isNaN(date.getTime())) return '';
    return date.toISOString().substring(0, 10);
  }

  private saveToStorage() {
    const key = 'filtros_busca_imobiliario';
    let filtros: any[] = [];
    const atual = localStorage.getItem(key);
    if (atual) {
      try {
        filtros = JSON.parse(atual);
      } catch {}
    }
    filtros = filtros.filter((f) => f.filtroGrupo !== 'Término da Obra');

    if (this.dataInicio || this.dataFim) {
      filtros.push({
        filtroGrupo: 'Término da Obra',
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
      });
    }
    localStorage.setItem(key, JSON.stringify(filtros));

    this.terminoObraChange.emit({
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
    });
  
  }
}
